import { render, staticRenderFns } from "./ServicesStatsSummary.vue?vue&type=template&id=6b33bc91&"
import script from "./ServicesStatsSummary.vue?vue&type=script&lang=ts&"
export * from "./ServicesStatsSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports